/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LocationContactBlock = function () {
  function LocationContactBlock() {
    _classCallCheck(this, LocationContactBlock);
    this.locationContactBlocks = document.querySelectorAll('.field--name-field-location-contact-block');
    if (this.locationContactBlocks.length > 0) {
      this.blockTexts = this.locationContactBlocks[0].querySelectorAll('.location-amount-text');
      this.nodeId = this.locationContactBlocks[0].querySelector('.node-id').textContent;
      this.singularText = this.locationContactBlocks[0].querySelector('.singular-text').textContent;
      this.pluralText = this.locationContactBlocks[0].querySelector('.plural-text').textContent;
    }
  }
  return _createClass(LocationContactBlock, [{
    key: "setBlockText",
    value: function setBlockText(locAmount) {
      var _this = this;
      this.blockTexts.forEach(function (text) {
        if (locAmount === 1) {
          text.textContent = "".concat(locAmount, " ").concat(_this.singularText, " ").concat(text.textContent);
        } else {
          text.textContent = "".concat(locAmount, " ").concat(_this.pluralText, " ").concat(text.textContent);
        }
      });
    }
  }, {
    key: "getJsonApiData",
    value: function getJsonApiData() {
      var _this2 = this;
      if (window.location.pathname && this.locationContactBlocks.length > 0) {
        fetch("/".concat(window.location.pathname.split('/')[1], "/jsonapi/node/location?filter[field_cond_serv_treat_list.meta.drupal_internal__target_id]=").concat(this.nodeId)).then(function (response) {
          return response.json();
        }).then(function (data) {
          _this2.setBlockText(data.data.length);
        }).catch(function () {});
      }
    }
  }]);
}();
export { LocationContactBlock as default };
(function () {
  var locationContactBlock = new LocationContactBlock();
  locationContactBlock.getJsonApiData();
})(Drupal);